import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Skeleton } from "antd";
import moment from "moment";

import partnersApi from "../../apis/Partners.api";
import summaryApi from "../../apis/Summary.api";

import SignupPercent from "./activeUser/SignupPercent";
import UnAnsweredComment from "./activeUser/UnAnsweredComment";
import { negativeColor, positiveColor } from "./BannerAlgorithm";

const ActiveUser = () => {
	const user = useSelector((state) => state.auth.user);
	const [loading, setLoading] = useState(false);
	const [percentLoading, setPercentLoading] = useState(false);

	const [userCount, setUserCount] = useState({
		now: 0,
		last_week: 0,
		last_month: 0,
		compare_month: 0,
		compare_week: 0,
	});

	const [comparePercentage, setComparePercentage] = useState({
		inflow: 0,
		signup: 0,
	});

	useEffect(() => {
		if (user?.id) {
			const timer = setTimeout(() => {
				getUserCount();
				getUserThatTime();
			}, 100);
			return () => clearTimeout(timer);
		}
		return () => {
			setLoading(false);
		};
	}, [user]);

	const getUserCount = useCallback(async () => {
		setLoading(true);
		const param = {
			endDate: moment().endOf("days").format("YYYYMMDDHHmm"),
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
		};
		const week = {
			endDate: moment()
				.subtract(1, "week")
				.endOf("days")
				.format("YYYYMMDDHHmm"),
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
		};
		const month = {
			endDate: moment()
				.subtract(1, "months")
				.endOf("months")
				.format("YYYYMMDDHHmm"),
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
		};

		const res = await partnersApi.readSignUpUserCount(param);
		const resW = await partnersApi.readSignUpUserCount(week);
		const resM = await partnersApi.readSignUpUserCount(month);
		// console.log(res, resM);
		// console.log(res.result.userSummaryList.map((item) => item.userCount));
		if (res.code === 200 && resW.code === 200 && resM.code === 200) {
			setUserCount({
				now: res.result?.userCount,
				last_week: resW.result?.userCount,
				last_month: resM.result?.userCount,
				compare_month: res.result?.userCount - resM.result?.userCount,
				compare_week: res.result?.userCount - resW.result?.userCount,
			});
		} else {
			setUserCount({
				now: 0,
				last_week: 0,
				last_month: 0,
				compare_month: 0,
				compare_week: 0,
			});
		}
		setLoading(false);
	}, []);

	const getUserThatTime = useCallback(async () => {
		setPercentLoading(true);
		const paramNow = {
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			startDate: moment("2023-01-01").startOf("days").format("YYYYMMDDHHmm"),
			endDate: moment().endOf("days").format("YYYYMMDDHHmm"),
		};
		const res = await summaryApi.readDashboardUserThatTime(paramNow);

		let nowValue = {
			inflow: 0,
			signup: 0,
			like_num: 0,
			comment_num: 0,
			view_num: 0,
		};
		if (res.code === 200) {
			const now = res.result;
			let inflow = now.filter((item) => item.action === "first_inflow");
			let signup = now.filter((item) => item.action === "signup");

			nowValue = {
				...nowValue,
				inflow: inflow?.length ?? 0,
				signup: signup?.length ?? 0,
			};
			setComparePercentage(nowValue);
		}
		setPercentLoading(false);
	}, []);
	return (
		<div
			className={`dashboard-component`}
			style={{
				height: "fit-content",
				width: "100%",
			}}
		>
			<h3>가입자 활동</h3>
			<div className={`dashboard-component-chart-bottom`}>
				<div style={{ display: "flex" }}>
					<div
						className={`dashboard-point-with-img-div`}
						style={{ width: "100%", alignItems: "flex-start" }}
					>
						<Skeleton
							loading={loading || percentLoading}
							active={loading}
							size={"large"}
							block={true}
							className={`skeleton-point-price`}
							style={{
								height: "6em",
							}}
							title={null}
							paragraph={{
								rows: 3,
								width: "100%",
							}}
						>
							<p className={`dark-gray`}>현재 가입자 수</p>
							<div
								style={{
									display: "flex",
									alignItems: "baseline",
									gap: 5,
								}}
							>
								<h1>{userCount?.now?.toLocaleString()}</h1>
								<b>명</b>
								<img
									src={`/assets/images/dashboard/${
										userCount?.compare_month > 0
											? "blue-up"
											: userCount?.compare_month < 0
											? "red-down"
											: "middle"
									}.png`}
									alt={`대시보드 경고 아이콘`}
									style={{
										width: "1.8em",
										height: "1.8em",
										marginLeft: 5,
									}}
								/>
							</div>
							<p className={`dark-gray`}>
								지난 달 대비
								<span
									style={{
										color:
											userCount?.compare_month > 0
												? // ? "#df1d1d"
												  positiveColor
												: userCount?.compare_month < 0
												? negativeColor
												: "inherit",
									}}
								>
									{" "}
									{Math.abs(userCount?.compare_month)?.toLocaleString()}명{" "}
									{userCount?.compare_month >= 0 ? "증가" : "감소"}
								</span>
							</p>
						</Skeleton>
					</div>
				</div>
			</div>

			{/* 가입율 */}
			<SignupPercent
				percentage={{
					...comparePercentage,
					signup: userCount?.now,
				}}
				loading={percentLoading}
			/>

			{/* 응답하지 않은 댓글 */}
			<UnAnsweredComment />

			<div
				className={`dashboard-component-footer`}
				style={{ justifyContent: "space-between" }}
			>
				<Link to={`/user_manage`} className={`dashboard-footer-font`}>
					회원관리로 이동
				</Link>
				<Link to={`/user_comment_manage`} className={`dashboard-footer-font`}>
					댓글관리로 이동
				</Link>
			</div>
		</div>
	);
};

export default ActiveUser;
